jQuery(document).ready(() => {
	const articlesWrapper = document.querySelector('#articles-wrapper');
	if (!articlesWrapper) return;

	function generateESGArticleCard(articleInfo) {
		let card = '';
		card += `<div class="esg-article-card">`;
			card += `<a href="${articleInfo.permalink}" target="_blank">`;
				card += `<img src="${articleInfo.img}" />`;
				card += `<h4>${articleInfo.title}</h4>`;
			card += '</a>';
		card += '</div>';
		return card;
	}

	function filterESGArticles(slug='') {
		let newHTML;
		if (slug == '') {
			newHTML = window.esg_articles_data
				.map(a => generateESGArticleCard(a))
				.join('');
		} else {
			newHTML = window.esg_articles_data
				.filter(article => article.categories.includes(slug))
				.map(a => generateESGArticleCard(a))
				.join('');
		}

		articlesWrapper.innerHTML = newHTML;
	}

	filterESGArticles();

	document.querySelectorAll('button').forEach(btn => {
		btn.addEventListener('click', e => {
			filterESGArticles(e.target.dataset.termSlug);
		});
	});
});
